import SEO from "@/components/site/SEO";
import LegalLayout, { LegalSection } from "@/components/site/LegalLayout";

export default function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="Altin Link Privacy Policy — how we collect, use, store and protect personal data in compliance with the EU GDPR and the Turkish Personal Data Protection Law (KVKK)."
        path="/privacy-policy"
      />
      <LegalLayout
        testid="privacy-page"
        overline="Privacy Policy"
        title="Privacy"
        accent="Policy"
        intro="This Privacy Policy explains how Altin Link Danışmanlık Hizmetleri Ltd. Şti. collects, uses and protects your personal data, in accordance with the EU General Data Protection Regulation (GDPR) and the Turkish Personal Data Protection Law No. 6698 (KVKK)."
        updated="December 2025"
      >
        <LegalSection index="01" id="privacy-controller" title="Data Controller">
          <p>
            The data controller responsible for your personal data is Altin Link
            Danışmanlık Hizmetleri Ltd. Şti., İstanbul, Türkiye. You may contact
            us at{" "}
            <a href="mailto:privacy@altin-link.com" className="text-altin-gold underline underline-offset-2">
              privacy@altin-link.com
            </a>{" "}
            regarding any privacy matter.
          </p>
        </LegalSection>

        <LegalSection index="02" id="privacy-collection" title="Data We Collect">
          <p>We may collect and process the following categories of personal data:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity and contact data (name, company, email, phone number) submitted through our contact or newsletter forms.</li>
            <li>Business information you voluntarily provide about your commercial requirements.</li>
            <li>Technical data such as IP address, browser type, device information and pages visited, collected via cookies and analytics.</li>
          </ul>
          <p>
            We only collect data that is necessary for the purposes described in
            this policy and process it lawfully, fairly and transparently.
          </p>
        </LegalSection>

        <LegalSection index="03" id="privacy-purpose" title="How We Use Your Data">
          <p>Your personal data is used to:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Respond to enquiries and provide brokerage and consulting services.</li>
            <li>Send business updates or our newsletter where you have subscribed.</li>
            <li>Comply with legal, regulatory and compliance obligations (including AML/KYC).</li>
            <li>Improve our website, security and user experience.</li>
          </ul>
          <p>
            Our legal bases for processing include your consent, the performance
            of a contract, our legitimate business interests and compliance with
            legal obligations.
          </p>
        </LegalSection>

        <LegalSection index="04" id="privacy-cookies" title="Cookies">
          <p>
            Our website uses cookies and similar technologies to operate the
            site and understand usage. You can manage your preferences at any
            time. For full details, please see our Cookie Policy.
          </p>
        </LegalSection>

        <LegalSection index="05" id="privacy-rights" title="Your Rights">
          <p>
            Under the GDPR and KVKK you have the right to access, rectify, erase,
            restrict or object to the processing of your personal data, to data
            portability, and to withdraw consent at any time. Under KVKK you also
            have the right to learn whether your data is processed, to request
            information about the processing, and to request correction or
            deletion.
          </p>
          <p>
            To exercise any of these rights, contact{" "}
            <a href="mailto:privacy@altin-link.com" className="text-altin-gold underline underline-offset-2">
              privacy@altin-link.com
            </a>
            . You also have the right to lodge a complaint with a supervisory
            authority (in Türkiye, the KVKK Authority).
          </p>
        </LegalSection>

        <LegalSection index="06" id="privacy-retention" title="Data Retention">
          <p>
            We retain personal data only for as long as necessary to fulfil the
            purposes for which it was collected, including to satisfy any legal,
            accounting, tax or reporting requirements. When data is no longer
            required, it is securely deleted or anonymised.
          </p>
        </LegalSection>

        <LegalSection index="07" id="privacy-security" title="Security">
          <p>
            We implement appropriate technical and organisational measures to
            protect personal data against unauthorised access, alteration,
            disclosure or destruction. Access to personal data is restricted to
            authorised personnel bound by confidentiality obligations.
          </p>
        </LegalSection>

        <LegalSection index="08" id="privacy-transfers" title="International Transfers">
          <p>
            Where personal data is transferred outside Türkiye or the European
            Economic Area, we ensure appropriate safeguards are in place in
            accordance with GDPR and KVKK requirements.
          </p>
        </LegalSection>

        <LegalSection index="09" id="privacy-contact" title="Contact Us">
          <p>
            For any questions about this Privacy Policy or how we handle your
            personal data, contact us at{" "}
            <a href="mailto:privacy@altin-link.com" className="text-altin-gold underline underline-offset-2">
              privacy@altin-link.com
            </a>{" "}
            or by post at Altin Link Danışmanlık Hizmetleri Ltd. Şti., Venezia
            Mall, J Block No: 01, İstanbul, Türkiye.
          </p>
        </LegalSection>
      </LegalLayout>
    </>
  );
}
